var map = {
	"./app.svg": 2418,
	"./avatar-01.svg": 38,
	"./avatar-02.svg": 6261,
	"./avatar-03.svg": 8244,
	"./avatar-female.svg": 899,
	"./avatar-male.svg": 6192,
	"./brinde.svg": 9945,
	"./cadeado.svg": 6106,
	"./caixa-calendario.svg": 54,
	"./caixa-clock.svg": 7830,
	"./caixa-ok.svg": 530,
	"./caixa-retirar.svg": 8237,
	"./caixa-seta.svg": 3741,
	"./caixa-timer.svg": 1079,
	"./caixa.svg": 1939,
	"./calculadora.svg": 8970,
	"./calendario.svg": 9583,
	"./card-cvv.svg": 6851,
	"./carrinho.svg": 4431,
	"./cartao-cvc.svg": 7618,
	"./cartao.svg": 4483,
	"./cesta.svg": 1185,
	"./checkbox.svg": 4590,
	"./combos-e-kits.svg": 3608,
	"./copy.svg": 7990,
	"./desconto.svg": 9086,
	"./drink.svg": 5037,
	"./edit.svg": 4029,
	"./entrega-01.svg": 8373,
	"./entrega-agendamento.svg": 4799,
	"./entrega-ok.svg": 4906,
	"./estrela.svg": 4301,
	"./exclamacao-triangulo.svg": 2043,
	"./exclamacao.svg": 8681,
	"./external-link.svg": 9625,
	"./facebook.svg": 5261,
	"./falha.svg": 1767,
	"./file-pdf.svg": 2618,
	"./filtro.svg": 8223,
	"./flecha.svg": 5038,
	"./gelando.svg": 6761,
	"./gelo.svg": 2554,
	"./grid.svg": 6549,
	"./heart.svg": 2203,
	"./input-radio.svg": 1805,
	"./level-easy.svg": 564,
	"./level-hard.svg": 3233,
	"./level-medium.svg": 9603,
	"./list.svg": 6649,
	"./lixeira.svg": 8853,
	"./local-loja.svg": 4443,
	"./logo-imigrantes.svg": 5522,
	"./logo-lw.svg": 6082,
	"./logo-simbolo.svg": 9068,
	"./lojinha.svg": 2392,
	"./lupa.svg": 9161,
	"./mail-01.svg": 9928,
	"./mail-02.svg": 4315,
	"./mail-03.svg": 3946,
	"./mais.svg": 3547,
	"./mapa.svg": 8162,
	"./menos.svg": 9057,
	"./menu.svg": 9540,
	"./ok.svg": 5415,
	"./password-hide.svg": 6447,
	"./password-show.svg": 9908,
	"./paypal.svg": 6844,
	"./pedido.svg": 4034,
	"./phone.svg": 9835,
	"./pin.svg": 3318,
	"./pix.svg": 9464,
	"./pontos.svg": 9702,
	"./presente-garrafas.svg": 1673,
	"./presente.svg": 6079,
	"./regras.svg": 1361,
	"./retirar-na-loja.svg": 845,
	"./sac.svg": 2592,
	"./sair.svg": 6212,
	"./sale.svg": 6616,
	"./social-fb.svg": 2821,
	"./social-instagram.svg": 6263,
	"./social-whatsapp.svg": 7951,
	"./spin.svg": 3165,
	"./substituicao.svg": 4268,
	"./tag-desconto.svg": 1699,
	"./tasting-and-talk.svg": 982,
	"./timer-reativar.svg": 9289,
	"./timer.svg": 2008,
	"./timer1.svg": 3417,
	"./twitter.svg": 954,
	"./whatsapp.svg": 2159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6046;